import { SkeletonLoader } from '@lab39/react-ui';
import styles from './ToolPageSkeleton.module.css';

const ToolPageSkeleton = () => {
  return (
    <div className={styles.wrapper}>
      <div className="container">
        {/* Tool Header */}
        <div className={styles.toolHeader}>
          <div className={styles.headerTop}>
            <SkeletonLoader variant="text" width="200px" height="40px" />
            <SkeletonLoader variant="rectangular" width="120px" height="40px" />
          </div>
          <SkeletonLoader variant="text" width="60%" height="20px" />
        </div>

        {/* Tool Content */}
        <div className={styles.toolContent}>
          {/* Input Section */}
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <SkeletonLoader variant="text" width="100px" height="24px" />
              <SkeletonLoader variant="rectangular" width="80px" height="36px" />
            </div>
            <SkeletonLoader variant="rectangular" width="100%" height="300px" />
            
            {/* Action Buttons */}
            <div className={styles.actions}>
              <SkeletonLoader variant="rectangular" width="120px" height="40px" />
              <SkeletonLoader variant="rectangular" width="120px" height="40px" />
              <SkeletonLoader variant="rectangular" width="100px" height="40px" />
            </div>
          </div>

          {/* Output Section */}
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <SkeletonLoader variant="text" width="100px" height="24px" />
              <SkeletonLoader variant="rectangular" width="80px" height="36px" />
            </div>
            <SkeletonLoader variant="rectangular" width="100%" height="300px" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolPageSkeleton;
